module.exports = __webpack_public_path__ + "static/media/video1.1c01118.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/video1.mp4
// module id = m05C
// module chunks = 0